<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        Receipt Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="grid">List</vs-button>
      <p class="pr-4"></p>
      <vs-button color="success" type="filled" icon="add" @click="cusAdd">Add</vs-button>
      <p class="pr-4"></p>
      <vs-button color="warning" type="filled" icon="create" @click="cusEdit" v-if="btndis">Edit</vs-button>
      <p class="pr-4"></p>
      <vs-button color="danger" type="filled" icon="remove_circle_outline" @click="cusDel"
        v-if="btndis">Delete</vs-button>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="list" @click="goPrint" v-if="btndis">Print</vs-button>
      <p class="pr-4"></p>
      <vs-button color="success" type="filled" icon="list" @click="goDetail" v-if="btndis">Detail</vs-button>
      <p class="pr-4"></p>
      <vs-button color="warning" type="filled" icon="repeat" @click="goResponse" v-if="btndis">Oracle
        Response</vs-button>
    </div>

    <transition-group enter-active-class="animated lightSpeedIn" leave-active-class="animated lightSpeedOut">
      <putadd v-if="addshow" :key="addshow" :acstate="acstate" :recid="recid" @grid="grid"
        :companyGroupsCode="companyGroupsCode" :businessPartnersCode="businessPartnersCode"></putadd>
      <aggrid v-if="gridshow" :key="gridshow" :masrec="masrec" @recsel="recsel" :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"></aggrid>
    </transition-group>
  </div>
</template>

<script>
// import aggrid from "./DataTable/AgGrid";
import aggrid from "./grid";
import putadd from "./putadd";

import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/custom-fonts";
import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      arData: [],
      arData2: [],
      totalGw: 0,
      totalPck: 0,
      totalWithVat: 0,
      amountTotal: 0,
      vatTotal: 0,
      whtTotal: 0,
      businessPartnersCode: "",
      userid: "",
      companyGroupsCode: "",
      addshow: false,
      gridshow: false,
      btndis: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      masrec: null,
      fabact: [
        { act: "cusAdd", label: "Add" },
        { act: "cusEdit", label: "Edit" },
        { act: "cusDel", label: "Delete" },
        { act: "goPrint", label: "PrintQR" },
        { act: "goDetail", label: "Inbdetails" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    ThaiNumberToText(Number) {
      Number = Number.replace(/๐/gi, "0");
      Number = Number.replace(/๑/gi, "1");
      Number = Number.replace(/๒/gi, "2");
      Number = Number.replace(/๓/gi, "3");
      Number = Number.replace(/๔/gi, "4");
      Number = Number.replace(/๕/gi, "5");
      Number = Number.replace(/๖/gi, "6");
      Number = Number.replace(/๗/gi, "7");
      Number = Number.replace(/๘/gi, "8");
      Number = Number.replace(/๙/gi, "9");
      return this.ArabicNumberToText(Number);
    },
    ArabicNumberToText(inNumber) {
      let Number = this.CheckNumber(inNumber);
      let NumberArray = new Array(
        "ศูนย์",
        "หนึ่ง",
        "สอง",
        "สาม",
        "สี่",
        "ห้า",
        "หก",
        "เจ็ด",
        "แปด",
        "เก้า",
        "สิบ"
      );
      let DigitArray = new Array(
        "",
        "สิบ",
        "ร้อย",
        "พัน",
        "หมื่น",
        "แสน",
        "ล้าน"
      );
      let BahtText = "";
      if (isNaN(Number)) {
        return "ข้อมูลนำเข้าไม่ถูกต้อง";
      } else {
        if (Number - 0 > 9999999.9999) {
          return "ข้อมูลนำเข้าเกินขอบเขตที่ตั้งไว้";
        } else {
          Number = Number.split(".");
          if (Number[1].length > 0) {
            Number[1] = Number[1].substring(0, 2);
          }
          let NumberLen = Number[0].length - 0;
          for (let i = 0; i < NumberLen; i++) {
            let tmp = Number[0].substring(i, i + 1) - 0;
            if (tmp != 0) {
              if (i == NumberLen - 1 && tmp == 1) {
                BahtText += "เอ็ด";
              } else if (i == NumberLen - 2 && tmp == 2) {
                BahtText += "ยี่";
              } else if (i == NumberLen - 2 && tmp == 1) {
                BahtText += "";
              } else {
                BahtText += NumberArray[tmp];
              }
              BahtText += DigitArray[NumberLen - i - 1];
            }
          }
          BahtText += "บาท";
          if (Number[1] == "0" || Number[1] == "00") {
            BahtText += "ถ้วน";
          } else {
            let DecimalLen = Number[1].length - 0;
            for (let i = 0; i < DecimalLen; i++) {
              let tmp = Number[1].substring(i, i + 1) - 0;
              if (tmp != 0) {
                if (i == DecimalLen - 1 && tmp == 1) {
                  BahtText += "เอ็ด";
                } else if (i == DecimalLen - 2 && tmp == 2) {
                  BahtText += "ยี่";
                } else if (i == DecimalLen - 2 && tmp == 1) {
                  BahtText += "";
                } else {
                  BahtText += NumberArray[tmp];
                }
                BahtText += DigitArray[DecimalLen - i - 1];
              }
            }
            BahtText += "สตางค์";
          }
          return BahtText;
        }
      }
    },
    CheckNumber(Number) {
      var decimal = false;
      Number = Number.toString();
      Number = Number.replace(/ |,|บาท|฿/gi, "");
      for (var i = 0; i < Number.length; i++) {
        if (Number[i] == ".") {
          decimal = true;
        }
      }
      if (decimal == false) {
        Number = Number + ".00";
      }
      return Number;
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    recsel(val) {
      this.btndis = true;
      this.recid = val;
    },
    grid() {
      this.addshow = false;
      this.gridshow = true;
      this.btndis = false;
      this.$store.dispatch("setReportGrid", 0);
    },
    goDetail() {
      this.btndis = true;
      this.$router.replace("/receiptsdetails/" + this.recid);
    },
    goResponse() {
      this.btndis = true;
      this.$router.replace("/billingresponse/" + this.recid);
    },
    goDate() {
      let today = new Date();
      let dd = today.getDate();

      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      this.daday = dd;
      this.damonth = mm;
      this.dayear = Number(yyyy) + 543;
      this.dtoday = dd + "-" + mm + "-" + yyyy;
    },
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    newFormatNumber(value) {
      const bigDecimal = require('js-big-decimal');
      // Convert the value to a BigDecimal
      let bdValue = new bigDecimal(value);

      // Round up the value using the scale
      let roundedUp = bdValue.round(2, bigDecimal.RoundingModes.HALF_UP);

      // Convert the result to a number and format it with commas
      let roundedNumber = parseFloat(roundedUp.getValue());
      return roundedNumber.toLocaleString('en-US', { minimumFractionDigits: 2 });


    },
    getArrayData(data) {
      // console.log(data);
      this.arData = [];

      this.totalGw = 0;
      this.totalPck = 0;
      this.amountTotal = 0;
      this.vatTotal = 0;
      this.whtTotal = 0;
      this.totalWithVat = 0;

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 8,
            bold: true,
            alignment: "center",
          },
          {
            text: item.description + " " + item.remarkDetail,
            fontSize: 8,
            bold: true,
            alignment: "left",
          },
          {
            text: this.newFormatNumber(item.qtyAmount),
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
          {
            text: item.qtyUnit,
            fontSize: 8,
            bold: true,
            alignment: "center",
          },
          {
            text: this.newFormatNumber(item.unitPrice),
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
          {
            text: this.newFormatNumber(item.totalAmount),
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
        ]);

        i++;

        // this.totalGw = this.totalGw + item.itemgw;
        // this.totalPck = this.totalPck + item.itempck;
        // this.amountTotal = this.amountTotal + item.totalAmount;
        // this.vatTotal = this.vatTotal + item.amountVat;
        // this.whtTotal = this.whtTotal + item.amountWht;
        // this.totalWithVat = this.amountTotal + this.vatTotal - this.whtTotal;
        // console.log(item.totalgw);
      });
    },
    getArrayData2(data) {
      // console.log(data);
      this.arData2 = [];

      this.totalGw = 0;
      this.totalPck = 0;
      this.amountTotal = 0;
      this.vatTotal = 0;
      this.whtTotal = 0;
      this.totalWithVat = 0;

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData2.push([
          {
            text: i,
            fontSize: 8,
            bold: true,
            alignment: "center",
          },
          {
            text: item.description + " " + item.remarkDetail,
            fontSize: 8,
            bold: true,
            alignment: "left",
          },
          {
            text: this.newFormatNumber(item.qtyAmount),
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
          {
            text: item.qtyUnit,
            fontSize: 8,
            bold: true,
            alignment: "center",
          },
          {
            text: this.newFormatNumber(item.unitPrice),
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
          {
            text: this.newFormatNumber(item.totalAmount),
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
        ]);

        i++;

        // this.totalGw = this.totalGw + item.itemgw;
        // this.totalPck = this.totalPck + item.itempck;
        // this.amountTotal = this.amountTotal + item.totalAmount;
        // this.vatTotal = this.vatTotal + item.amountVat;
        // this.whtTotal = this.whtTotal + item.amountWht;
        // this.totalWithVat = this.amountTotal + this.vatTotal - this.whtTotal;
        // console.log(item.totalgw);
      });
    },
    getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          // var dataURL = canvas.toDataURL("image/png");
          var dataURL = canvas.toDataURL("image/png");

          resolve(dataURL);
        };

        img.onerror = (error) => {
          reject(error);
        };

        img.src = url;
      });
    },
    async goPrint() {
      const moment = require("moment");

      this.contents = [];

      this.goDate();

      this.btndis = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        this.loading = true;

        if (token) {
          const formData = {
            companyGroupsCode: this.companyGroupsCode,
            number: this.recid,
            // from: '2022-01-11'
          };

          const response = await axios.post(
            `${BASE_API_URL}/billing-svc/receipts/printReceipts`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            // console.log(response.data)
            this.getArrayData(response.data.receipts);
            this.getArrayData2(response.data.receipts);

            const footerContent = [
              {
                margin: [50, -70, 0, 57],
                text: "Rejection should be made within 7 days of receiving invoice, otherwise the Receipt/Tax Invoice will be deemed correet.",
                bold: true,
                fontSize: 10,
              },
              {
                margin: [40, 0, 0, 0],
                table: {
                  height: 70,
                  widths: [150, 200, 150], // 525
                  body: [
                    [
                      [
                        {
                          rowSpan: 2,
                          text: "",
                          fontSize: 10,
                          alignment: "center",
                          margin: [0, 0, 0, 5],
                        },
                        {
                          text: "ผู้จัดทำเอกสาร " + response.data.receipts[0].editor,
                          fontSize: 10,
                          alignment: "center",
                          margin: [0, 0, 0, 5],
                        },
                        {
                          text: "วันที่ / Date " + this.cvDate(new Date()),
                          fontSize: 10,
                          alignment: "center",
                        },
                      ],
                      {
                        text: "",
                        bold: true,
                        fontSize: 10,
                        alignment: "center",
                        margin: [0, 20, 0, 0],
                      },
                      [
                        {
                          text: "",
                          fontSize: 10,
                          alignment: "center",
                          margin: [0, 0, 0, 5],
                        },
                        {
                          text: "ผู้รับเงิน__________________________",
                          fontSize: 10,
                          alignment: "center",
                          margin: [0, 0, 0, 5],
                        },
                        {
                          text: "วันที่ / Date _______________________ ",
                          fontSize: 10,
                          alignment: "center",
                        },
                      ],
                    ],
                  ],
                },

              },
            ];

            // first page
            this.contents.push(
              [
                {
                  margin: [0, -30, 0, 0],

                  image: "logo",
                  width: 120,
                },
                {
                  margin: [140, -32, 0, 0],
                  text: "บริษัท บริการภาคพื้น ท่าอากาศยานไทย จำกัด",
                  bold: true,
                  fontSize: 14,
                },
                {
                  margin: [140, 0, 0, 10],
                  text: "AOT Ground Aviation Services Co.,Ltd.",
                  bold: true,
                  fontSize: 14,
                },
                {
                  table: {
                    widths: [350, 150],
                    body: [
                      [
                        {
                          table: {
                            widths: ["*"],
                            body: [
                              [
                                {
                                  text: "สาขาที่ 00002 (สาขาท่าอากาศยานสุวรรณภูมิ)",
                                },
                              ],
                              [
                                {
                                  text: "999 หมู่ที่ 7 ตำบลราชาเทวะ อำเภอบางพลี จังหวัดสมุทรปราการ 10540",
                                },
                              ],
                              [
                                {
                                  text: "เลขประจำตัวผู้เสียภาษี 0105561176136 โทรศัพท์ 0641825397",
                                },
                              ],
                              [
                                {
                                  text: "Branch 00002 (Suvarnabhumi Airport Branch)",
                                },
                              ],
                              [
                                {
                                  text: "999 Moo 7, Racha Thewa Subdistrict, Bang Phli District, Samut Prakan 10540",
                                },
                              ],
                              [
                                {
                                  text: "TAX ID NO. 0105561176136 Tel. 0641825397",
                                },
                              ],
                              [
                                {
                                  table: {
                                    widths: [100, '*'],
                                    body: [
                                      [
                                        {
                                          border: [true, true, false, false],
                                          text: "รหัสลูกค้า / COD :"
                                        },
                                        {
                                          border: [false, true, true, false],
                                          text: response.data.receipts[0].businessPartnersCode,
                                        },
                                      ],
                                      [
                                        {
                                          border: [true, false, false, false],
                                          text: "ชื่อ / NAME :"
                                        },
                                        {
                                          border: [false, false, true, false],
                                          text: response.data.receipts[0].businessPartnersName,
                                        },
                                      ],
                                      [
                                        {
                                          border: [true, false, false, false],
                                          text: "ที่อยู่ / ADDRESS :"
                                        },
                                        {
                                          border: [false, false, true, false],
                                          text:
                                            response.data.receipts[0].eadd1 +
                                            " " +
                                            response.data.receipts[0].eamoo +
                                            " " +
                                            response.data.receipts[0].eabuild +
                                            " " +
                                            response.data.receipts[0].eafloor +
                                            " " +
                                            response.data.receipts[0].easoi +
                                            " " +
                                            response.data.receipts[0].earoad +
                                            " " +
                                            response.data.receipts[0].eadd2 +
                                            " " +
                                            response.data.receipts[0].eadd3 +
                                            " " +
                                            response.data.receipts[0].eadd4 +
                                            " " +
                                            response.data.receipts[0].zcode,
                                        },
                                      ],
                                      [
                                        {
                                          border: [true, false, false, false],
                                          text: "โทร. / TEL :"
                                        },
                                        {
                                          border: [false, false, true, false],
                                          text: response.data.receipts[0].telnum,
                                        },
                                      ],
                                      [
                                        {
                                          border: [true, false, false, false],
                                          text: "เลขประจำตัวผู้เสียภาษี / ID :"
                                        },
                                        {
                                          border: [false, false, true, false],
                                          text: response.data.receipts[0].taxid,
                                        },
                                      ],
                                      [
                                        {
                                          border: [true, false, false, true],
                                          text: "สาขา / BRANCH :"
                                        },
                                        {
                                          border: [false, false, true, true],
                                          text: response.data.receipts[0].branch,
                                        },
                                      ],
                                    ],
                                  },
                                },
                              ],
                            ],
                          },
                          layout: "noBorders",
                        },
                        {
                          table: {
                            widths: ["*"],
                            body: [
                              [
                                {
                                  text: "ใบเสร็จรับเงิน/ใบกำกับภาษี",
                                  bold: true,
                                  fontSize: 15,
                                  // style: "title",

                                  alignment: "center",
                                  margin: [0, -40, 0, 0],
                                },
                              ],
                              [
                                {
                                  text: "(Receipt)",
                                  bold: true,
                                  fontSize: 15,
                                  // style: "title",

                                  alignment: "center",
                                  margin: [0, -30, 0, 30],
                                },
                              ],
                              [
                                {
                                  text: "ต้นฉบับ (ORIGINAL)",
                                  bold: true,
                                  fontSize: 15,
                                  alignment: "center",
                                  margin: [0, 0, 0, 20],
                                },
                              ],
                              [
                                {
                                  table: {
                                    widths: [70, '*'],
                                    body: [
                                      [
                                        {
                                          alignment: "center",
                                          text: "เลขที่ / NO :"
                                        },
                                        {
                                          alignment: "center",
                                          text: response.data.receipts[0].receiptsNumber,
                                          bold: true,
                                        },
                                      ],
                                      [
                                        {
                                          alignment: "center",
                                          text: "วันที่ / DATE :"
                                        },
                                        {
                                          alignment: "center",
                                          text: moment(response.data.receipts[0].recdate).format("DD-MM-YYYY"),
                                          bold: true,
                                        },
                                      ],
                                    ],
                                  },
                                  layout: "noBorders",
                                },
                              ],
                              [
                                {
                                  alignment: "center",
                                  text:
                                    "Invoice Ref : " +
                                    response.data.receipts[0].invoicesNumber,
                                },
                              ],
                              [
                                {
                                  alignment: "center",
                                  text:
                                    "PAID BY : " +
                                    response.data.receipts[0].paymentType,
                                },
                              ],
                            ],
                          },
                          layout: "noBorders",
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                },
                {
                  margin: [0, 10, 0, 0],
                  text:
                    "PCS : " +
                    this.newFormatNumber(response.data.totalPck),
                },
                {
                  text:
                    "Weight : " +
                    this.newFormatNumber(response.data.totalGw),
                },
                {
                  text: "MAWB No. : " + response.data.mawb,
                },
                {
                  text: "HAWB No. : " + response.data.hawb,
                },
                {
                  text: "Inbound Shipment : " + response.data.shipments,
                },
                {
                  margin: [0, 0, 0, 10],
                  text: "Outbound Shipment : " + response.data.outbounds,
                },
                {
                  text: "",
                },
                {
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [30, 180, 65, 50, 61, 80], // 525
                    body: [
                      [
                        {
                          text: "ลำดับ" + "\n" + "NO.",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "รายละเอียด" + "\n" + "DESCRIPTION",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "จำนวน" + "\n" + "QUANTITY",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "หน่วย" + "\n" + "UNIT",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "ราคา/หน่วย" + "\n" + "UNIT PRICE",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "รายได้ค่าบริการ" + "\n" + "AMOUNT",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [30, 180, 65, 50, 61, 80], // 525
                    // body: this.getArray(response.data.message),
                    body: this.arData,
                    // body: [[{}, {}, {}, {}, {}]],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [30, 180, 65, 50, 61, 80], // 525
                    body: [
                      [
                        {
                          colSpan: 3,
                          rowSpan: 4,
                          text: "รวม",
                          bold: true,
                          fontSize: 12,
                          alignment: "left",
                        },
                        {},
                        {},
                        {
                          colSpan: 2,
                          text: "ยอดก่อน VAT",
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                        {},
                        {
                          text: this.newFormatNumber(response.data.amountBeforeVAT),
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                      ],
                      [
                        {},
                        {},
                        {},
                        {
                          colSpan: 2,
                          text: "VAT 7%",
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                        {},
                        {
                          text: this.newFormatNumber(response.data.VatAmount),
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                      ],
                      [
                        {},
                        {},
                        {},
                        {
                          colSpan: 2,
                          text: "ยอดรวม VAT",
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                        {},
                        {
                          text: this.newFormatNumber(response.data.amountWithVAT),
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                      ],
                      [
                        {},
                        {},
                        {},
                        {
                          colSpan: 2,
                          text: "ภาษีหัก ณ ที่จ่าย 3%",
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                        {},
                        {
                          text: this.newFormatNumber(response.data.WhtAmount),
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                      ],
                      [
                        {
                          colSpan: 3,
                          text: this.ArabicNumberToText(response.data.totalAmount + ""),
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {},
                        {},
                        {
                          colSpan: 2,
                          text: "รวมทั้งสิ้น",
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                        {},
                        {
                          text: this.newFormatNumber(response.data.totalAmount),
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                      ],
                    ],
                  },
                },
              ]
            )

            // second page
            this.contents.push(
              [
                {
                  margin: [0, -30, 0, 0],

                  image: "logo",
                  width: 120,
                  pageBreak: "before",
                },
                {
                  margin: [140, -32, 0, 0],
                  text: "บริษัท บริการภาคพื้น ท่าอากาศยานไทย จำกัด",
                  bold: true,
                  fontSize: 14,
                },
                {
                  margin: [140, 0, 0, 10],
                  text: "AOT Ground Aviation Services Co.,Ltd.",
                  bold: true,
                  fontSize: 14,
                },
                {
                  table: {
                    widths: [350, 150],
                    body: [
                      [
                        {
                          table: {
                            widths: ["*"],
                            body: [
                              [
                                {
                                  text: "สาขาที่ 00002 (สาขาท่าอากาศยานสุวรรณภูมิ)",
                                },
                              ],
                              [
                                {
                                  text: "999 หมู่ที่ 7 ตำบลราชาเทวะ อำเภอบางพลี จังหวัดสมุทรปราการ 10540",
                                },
                              ],
                              [
                                {
                                  text: "เลขประจำตัวผู้เสียภาษี 0105561176136 โทรศัพท์ 0641825397",
                                },
                              ],
                              [
                                {
                                  text: "Branch 00002 (Suvarnabhumi Airport Branch)",
                                },
                              ],
                              [
                                {
                                  text: "999 Moo 7, Racha Thewa Subdistrict, Bang Phli District, Samut Prakan 10540",
                                },
                              ],
                              [
                                {
                                  text: "TAX ID NO. 0105561176136 Tel. 0641825397",
                                },
                              ],
                              [
                                {
                                  table: {
                                    widths: [100, '*'],
                                    body: [
                                      [
                                        {
                                          border: [true, true, false, false],
                                          text: "รหัสลูกค้า / COD :"
                                        },
                                        {
                                          border: [false, true, true, false],
                                          text: response.data.receipts[0].businessPartnersCode,
                                        },
                                      ],
                                      [
                                        {
                                          border: [true, false, false, false],
                                          text: "ชื่อ / NAME :"
                                        },
                                        {
                                          border: [false, false, true, false],
                                          text: response.data.receipts[0].businessPartnersName,
                                        },
                                      ],
                                      [
                                        {
                                          border: [true, false, false, false],
                                          text: "ที่อยู่ / ADDRESS :"
                                        },
                                        {
                                          border: [false, false, true, false],
                                          text:
                                            response.data.receipts[0].eadd1 +
                                            " " +
                                            response.data.receipts[0].eamoo +
                                            " " +
                                            response.data.receipts[0].eabuild +
                                            " " +
                                            response.data.receipts[0].eafloor +
                                            " " +
                                            response.data.receipts[0].easoi +
                                            " " +
                                            response.data.receipts[0].earoad +
                                            " " +
                                            response.data.receipts[0].eadd2 +
                                            " " +
                                            response.data.receipts[0].eadd3 +
                                            " " +
                                            response.data.receipts[0].eadd4 +
                                            " " +
                                            response.data.receipts[0].zcode,
                                        },
                                      ],
                                      [
                                        {
                                          border: [true, false, false, false],
                                          text: "โทร. / TEL :"
                                        },
                                        {
                                          border: [false, false, true, false],
                                          text: response.data.receipts[0].telnum,
                                        },
                                      ],
                                      [
                                        {
                                          border: [true, false, false, false],
                                          text: "เลขประจำตัวผู้เสียภาษี / ID :"
                                        },
                                        {
                                          border: [false, false, true, false],
                                          text: response.data.receipts[0].taxid,
                                        },
                                      ],
                                      [
                                        {
                                          border: [true, false, false, true],
                                          text: "สาขา / BRANCH :"
                                        },
                                        {
                                          border: [false, false, true, true],
                                          text: response.data.receipts[0].branch,
                                        },
                                      ],
                                    ],
                                  },
                                },
                              ],
                            ],
                          },
                          layout: "noBorders",
                        },
                        {
                          table: {
                            widths: ["*"],
                            body: [
                              [
                                {
                                  text: "ใบเสร็จรับเงิน/ใบกำกับภาษี",
                                  bold: true,
                                  fontSize: 15,
                                  // style: "title",

                                  alignment: "center",
                                  margin: [0, -40, 0, 0],
                                },
                              ],
                              [
                                {
                                  text: "(Receipt)",
                                  bold: true,
                                  fontSize: 15,
                                  // style: "title",

                                  alignment: "center",
                                  margin: [0, -30, 0, 30],
                                },
                              ],
                              [
                                {
                                  text: "สำเนา (COPY)",
                                  bold: true,
                                  fontSize: 15,
                                  alignment: "center",
                                  margin: [0, 0, 0, 20],
                                },
                              ],
                              [
                                {
                                  table: {
                                    widths: [70, '*'],
                                    body: [
                                      [
                                        {
                                          alignment: "center",
                                          text: "เลขที่ / NO :"
                                        },
                                        {
                                          alignment: "center",
                                          text: response.data.receipts[0].receiptsNumber,
                                          bold: true,
                                        },
                                      ],
                                      [
                                        {
                                          alignment: "center",
                                          text: "วันที่ / DATE :"
                                        },
                                        {
                                          alignment: "center",
                                          text: moment(response.data.receipts[0].recdate).format("DD-MM-YYYY"),
                                          bold: true,
                                        },
                                      ],
                                    ],
                                  },
                                  layout: "noBorders",
                                },
                              ],
                              [
                                {
                                  alignment: "center",
                                  text:
                                    "Invoice Ref : " +
                                    response.data.receipts[0].invoicesNumber,
                                },
                              ],
                              [
                                {
                                  alignment: "center",
                                  text:
                                    "PAID BY : " +
                                    response.data.receipts[0].paymentType,
                                },
                              ],
                            ],
                          },
                          layout: "noBorders",
                        },
                      ],
                    ],
                  },
                  layout: "noBorders",
                },
                {
                  margin: [0, 10, 0, 0],
                  text:
                    "PCS : " +
                    this.newFormatNumber(response.data.totalPck),
                },
                {
                  text:
                    "Weight : " +
                    this.newFormatNumber(response.data.totalGw),
                },
                {
                  text: "MAWB No. : " + response.data.mawb,
                },
                {
                  text: "HAWB No. : " + response.data.hawb,
                },
                {
                  text: "Inbound Shipment : " + response.data.shipments,
                },
                {
                  margin: [0, 0, 0, 10],
                  text: "Outbound Shipment : " + response.data.outbounds,
                },
                {
                  text: "",
                },
                {
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [30, 180, 65, 50, 61, 80], // 525
                    body: [
                      [
                        {
                          text: "ลำดับ" + "\n" + "NO.",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "รายละเอียด" + "\n" + "DESCRIPTION",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "จำนวน" + "\n" + "QUANTITY",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "หน่วย" + "\n" + "UNIT",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "ราคา/หน่วย" + "\n" + "UNIT PRICE",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "รายได้ค่าบริการ" + "\n" + "AMOUNT",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [30, 180, 65, 50, 61, 80], // 525
                    // body: this.getArray(response.data.message),
                    body: this.arData2,
                    // body: [[{}, {}, {}, {}, {}]],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [30, 180, 65, 50, 61, 80], // 525
                    body: [
                      [
                        {
                          colSpan: 3,
                          rowSpan: 4,
                          text: "รวม",
                          bold: true,
                          fontSize: 12,
                          alignment: "left",
                        },
                        {},
                        {},
                        {
                          colSpan: 2,
                          text: "ยอดก่อน VAT",
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                        {},
                        {
                          text: this.newFormatNumber(response.data.amountBeforeVAT),
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                      ],
                      [
                        {},
                        {},
                        {},
                        {
                          colSpan: 2,
                          text: "VAT 7%",
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                        {},
                        {
                          text: this.newFormatNumber(response.data.VatAmount),
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                      ],
                      [
                        {},
                        {},
                        {},
                        {
                          colSpan: 2,
                          text: "ยอดรวม VAT",
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                        {},
                        {
                          text: this.newFormatNumber(response.data.amountWithVAT),
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                      ],
                      [
                        {},
                        {},
                        {},
                        {
                          colSpan: 2,
                          text: "ภาษีหัก ณ ที่จ่าย 3%",
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                        {},
                        {
                          text: this.newFormatNumber(response.data.WhtAmount),
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                      ],
                      [
                        {
                          colSpan: 3,
                          text: this.ArabicNumberToText(response.data.totalAmount + ""),
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {},
                        {},
                        {
                          colSpan: 2,
                          text: "รวมทั้งสิ้น",
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                        {},
                        {
                          text: this.newFormatNumber(response.data.totalAmount),
                          bold: true,
                          fontSize: 10,
                          alignment: "right",
                        },
                      ],
                    ],
                  },
                },
              ]
            )

            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",
              pageMargins: [40, 40, 40, 70],

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "portrait",
              header: (currentPage, pageCount) => {
                return {
                  columns: [
                    {
                      text: [
                        {
                          text: 'หน้า ' +
                            currentPage.toString() + " / " + pageCount + "\t\t",
                        },
                      ],
                      margin: [0, 10, 10, 0],
                      alignment: "right",
                    },
                  ],
                };
              },
              footer: footerContent,
              images: {
                // logo :'https://codingthailand.com/site/img/garuda_logo.png',
                logo: require("./login.png"),
              },
              content: this.contents,
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
                columnGap: 20,
              },
              styles: {
                title: {
                  fontSize: 20,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 2000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    cusAdd() {
      this.recid = 0;
      this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "ADD";
    },
    cusEdit() {
      this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "EDIT";
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Delete? " + this.recid,
        accept: this.acceptAlert,
      });
    },
    async acceptAlert() {
      this.btndis = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/billing-svc/receipts/delete`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Deleted Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    async goTrigger() {
      this.btndis = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/billing-svc/receipts/recTrigger`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Trigger Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          // this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  mounted() {
    this.checkProfiles();
    // console.log(this.$acl.check('admin'));
  },
  components: {
    aggrid,
    putadd,
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}

.fab {
  background-color: rgb(231, 55, 55);
}
</style>
